import React, { FC } from 'react'
import { IconProps, SIZES, SVG } from '../../exports'

/* Styles ======================================================================================== */
import { ProjectsDetailedStyled } from './projects-detailed.styled'

const ProjectsDetailed: FC<IconProps> = props => {
  const { size = 'xxl', isAnimated, color, ...others } = props
  const theme = {
    color: `${color ? color : 'currentColor'}`,
  }
  return (
    <ProjectsDetailedStyled
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={isAnimated !== undefined ? 'is-animated' : ''}
      theme={theme.color}
      {...SIZES[size]}
      {...others}
    >
      <path
        d="M42 8L43 8"
        className="stroke-bg stroke-bg-1 secondary-stroke-color"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39 12L45 12"
        className="stroke-bg stroke-bg-2 secondary-stroke-color"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M4 32L3 32"
        className="stroke-bg stroke-bg-3 secondary-stroke-color"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 41H9"
        className="stroke-bg stroke-bg-4 secondary-stroke-color"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1429 6C17.5117 6 17 6.51167 17 7.14286V8.28571H10.1429C9.51167 8.28571 9 8.79739 9 9.42857V36.8571C9 37.4883 9.51167 38 10.1429 38H31.8571C32.4883 38 33 37.4883 33 36.8571V9.42857C33 8.79739 32.4883 8.28571 31.8571 8.28571H25V7.14286C25 6.51167 24.4883 6 23.8571 6H18.1429Z"
        className="fill-bg primary-fill-color"
      />
      <path
        d="M37 14.5714V12.2857H29M13 31.7143V12.2857H21M13 38V42H37V36.2857"
        className="stroke stroke-path"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.517 18L42.2241 17.2929C42.0366 17.1054 41.7822 17 41.517 17C41.2518 17 40.9974 17.1054 40.8099 17.2929L41.517 18ZM45 21.483L45.7071 22.1901C46.0976 21.7996 46.0976 21.1664 45.7071 20.7759L45 21.483ZM41.517 24.966L40.8099 24.2589L40.8099 24.2589L41.517 24.966ZM30.8193 35.6637L30.9691 36.6525C31.1801 36.6205 31.3754 36.5218 31.5264 36.3709L30.8193 35.6637ZM27.3363 32.1808L26.6292 31.4737C26.4782 31.6246 26.3795 31.8199 26.3475 32.031L27.3363 32.1808ZM26.7143 36.2857L25.7256 36.1359C25.678 36.4501 25.7825 36.7681 26.0072 36.9928C26.2319 37.2175 26.5499 37.322 26.8641 37.2744L26.7143 36.2857ZM38.034 21.483L38.7411 22.1901L38.7411 22.1901L38.034 21.483ZM29.3742 31.5571C29.7647 31.1665 29.7647 30.5334 29.3742 30.1428C28.9837 29.7523 28.3505 29.7523 27.96 30.1428L29.3742 31.5571ZM30.7307 27.3721C30.3401 27.7627 30.3401 28.3958 30.7307 28.7863C31.1212 29.1769 31.7544 29.1769 32.1449 28.7863L30.7307 27.3721ZM39.0536 20.4634C38.6631 20.0729 38.0299 20.0729 37.6394 20.4634C37.2489 20.8539 37.2489 21.4871 37.6394 21.8776L39.0536 20.4634ZM41.1224 25.3606C41.5129 25.7511 42.1461 25.7511 42.5366 25.3606C42.9271 24.9701 42.9271 24.3369 42.5366 23.9464L41.1224 25.3606ZM40.8099 18.7071L44.2929 22.1901L45.7071 20.7759L42.2241 17.2929L40.8099 18.7071ZM44.2929 20.7759L40.8099 24.2589L42.2241 25.6731L45.7071 22.1901L44.2929 20.7759ZM40.8099 24.2589L30.1121 34.9566L31.5264 36.3709L42.2241 25.6731L40.8099 24.2589ZM26.3475 32.031L25.7256 36.1359L27.703 36.4355L28.325 32.3306L26.3475 32.031ZM28.0434 32.8879L29.3742 31.5571L27.96 30.1428L26.6292 31.4737L28.0434 32.8879ZM32.1449 28.7863L38.7411 22.1901L37.3269 20.7759L30.7307 27.3721L32.1449 28.7863ZM38.7411 22.1901L42.2241 18.7071L40.8099 17.2929L37.3269 20.7759L38.7411 22.1901ZM37.6394 21.8776L39.3809 23.6191L40.7951 22.2049L39.0536 20.4634L37.6394 21.8776ZM39.3809 23.6191L41.1224 25.3606L42.5366 23.9464L40.7951 22.2049L39.3809 23.6191ZM26.8641 37.2744L28.9166 36.9634L28.617 34.986L26.5645 35.297L26.8641 37.2744ZM28.9166 36.9634L30.9691 36.6525L30.6694 34.675L28.617 34.986L28.9166 36.9634Z"
        className="fill stroke-path"
      />
      <path
        d="M17.2374 26H21.5041V30.2667H17.2374V26Z"
        className="stroke stroke-path"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2374 33.4667H21.5041V37.7333H17.2374V33.4667Z"
        className="stroke stroke-path"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2374 18.5333H21.5041V22.8H17.2374V18.5333Z"
        className="stroke stroke-path"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.7795 20.6042H32.0938M24.7795 28.0396H25.6938"
        className="stroke stroke-path"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 10V9C20.4477 9 20 9.44772 20 10H21ZM29 10H30C30 9.44772 29.5523 9 29 9V10ZM29 14.5714V15.5714C29.5523 15.5714 30 15.1237 30 14.5714H29ZM21 14.5714H20C20 15.1237 20.4477 15.5714 21 15.5714V14.5714ZM21 11H29V9H21V11ZM28 10V14.5714H30V10H28ZM29 13.5714H21V15.5714H29V13.5714ZM22 14.5714V10H20V14.5714H22Z"
        className="fill stroke-path"
      />
    </ProjectsDetailedStyled>
  )
}

export default ProjectsDetailed
